import { graphql } from "@opensea/graphql"

export const getItemQuoteResultErrorFragment = graphql(`
  fragment getItemQuoteResultError on ItemQuoteResult {
    __typename
    ... on WithQuoteItem {
      item {
        chain {
          identifier
        }
        tokenId
        contractAddress
        name
        imageUrl
      }
    }

    ... on ItemNotFound {
      item {
        tokenId
        chain {
          identifier
        }
        contractAddress
      }
    }
    # Add more error types here
  }
`)
